var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{key:_vm.refreshKey,staticClass:"test-form"},[_c('parser',{ref:"paeserChild",attrs:{"form-conf":_vm.formData},on:{"submit":_vm.sumbitForm1}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }